import "./App.css";

function App() {
  return (
    <div className="App">
      <h1>Ciphers and codes</h1>
      <h2>Wjgir eljsurweuqlj</h2>
    </div>
  );
}

export default App;
